export default __webpack_public_path__ + "static/media/shareholder_example.122aca99.png";